import styled from "styled-components";

// TODO: Rename to "FullWidthContainer" and move into WidthContainers.js
const FullWidthDiv = styled.div`
  width: 100%;
`;

export default FullWidthDiv;
